const examination = {
    mba: {
        program: "MBA / PGDM",
        branchName: ["MBA", "PGDM"],
        branchTitle: "Program Intrested",
        exmaSlot: [
            "5th May, 2026, 01:00 PM to 03:00 PM",
        ],
        lof: "GRADUATION"
    },
    engg: {
        program: "ENGINEERING",
        exmaSlot: [
            "3rd May, 2026, 01:00 PM to 03:00 PM",
            "4th May, 2026, 01:00 PM to 03:00 PM",
            "6th May, 2026, 01:00 PM to 03:00 PM",
            "7th May, 2026, 01:00 PM to 03:00 PM"
        ],
        branchTitle: "Branch Preferences",
        branchName: [
            "Computer Science Engg",
            "Computer Science Engg with sepecialization (like AI, Data Science, ML or any other)",
            "Electronics & Communication Engg",
            "Electronics & Telecommunication Engg",
            "Electrical Engg",
            "Electrical & Electronics Engg",
            "Mechanical Engg",
            "Civil Engg",
            "Automobile Engg",
            "Aerospace Engg",
            "Any Other"
        ],
        lof: "PCM"
    },
    pcb: {
        program: "PCB",
        exmaSlot: [
            "5th May, 2026, 01:00 PM to 03:00 PM",
        ],
        branchTitle: "Program Intrested",
        branchName: [
            "B.Pharmacy",
            "Bsc.Nursing",
            "Bio –Technology",
            "Agriculture ( Bsc.Agriculture )", "BPT ( Bachelor of physiotherapy )"

        ],
        lof: "PCB"

    },
    pcm: {
        program: "PCM",
        exmaSlot: [
            "5th May, 2026, 01:00 PM to 03:00 PM"
        ],
        branchTitle: "Program Intrested",
        branchName: [

            "Bsc.Biotechnology", "B. Tech Biotechnology",
            "B.Pharmacy",
            "Aeronautical", "Aerospace Engineering",
            "B.Tech Agriculture ", "Bsc. Agriculture"

        ],
        lof: "PCM"
    },
    other: {
        program: "OTHER",
        exmaSlot: [
            "5th May, 2026, 01:00 PM to 03:00 PM"
        ],
        branchTitle: "Program Intrested",
        branchName: [
            "BBA", "BCA",
            "B. Design",
            "BA LLB", "BBA LLB", "BCA LLB", "B.COM LLB",
            "Mass Communication & Journalism ( BJMC )",
            "B.A", "B.Com", "B.Sc"
        ],
        lof: "Other"
    },
}

module.exports = examination